function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * @file dom DOM操作的一些函数
 */
import { getKeys, isWindow } from '@co-hooks/util';
/**
 * 是否客户端环境
 *
 */

export function isClient() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
}
var zIndex = 500;
/**
 * 获取zIndex
 *
 * @return 返回zIndex
 */

export function getZIndex() {
  return zIndex += 3;
}
export function getDefaultElementSize() {
  return {
    width: 0,
    height: 0
  };
}
export function getDefaultOffset() {
  return {
    x: 0,
    y: 0
  };
}
export function getDefaultElementPosition() {
  return {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 0,
    height: 0
  };
}
export function getDefaultOverflowBoundaries() {
  return {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
}
export function getWindowSize() {
  if (!isClient()) {
    return getDefaultElementSize();
  }

  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  };
}
export function swap(element, styles, callback) {
  var old = {};
  var keys = getKeys(styles);
  keys.forEach(function (key) {
    return old[key] = element.style[key];
  });
  Object.assign(element.style, styles);
  var result = callback();
  Object.assign(element.style, old);
  return result;
}
/**
 * 获取元素大小
 *
 * @param element 要获取的元素
 */

export function getElementSize(element) {
  if (!isClient()) {
    return getDefaultElementSize();
  }

  var _getElementPosition = getElementPosition(element),
      width = _getElementPosition.width,
      height = _getElementPosition.height;

  return {
    width: width,
    height: height
  };
}
/**
 * 获取元素位置
 *
 * @param element 要获取的元素
 */

export function getElementPosition(element) {
  if (!isClient()) {
    return getDefaultElementPosition();
  }

  var style = getComputedStyle(element);

  var getPosition = function getPosition() {
    var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height,
        top = _element$getBoundingC.top,
        left = _element$getBoundingC.left,
        right = _element$getBoundingC.right,
        bottom = _element$getBoundingC.bottom;

    return {
      width: width,
      height: height,
      top: top,
      left: left,
      right: right,
      bottom: bottom
    };
  };

  if (style.display !== 'none') {
    return getPosition();
  }

  return swap(element, {
    display: 'block'
  }, getPosition);
}
export function isElementSizeEqual(a, b) {
  return a.width === b.width && a.height === b.height;
}
export function isElementPositionEqual(a, b) {
  return isElementSizeEqual(a, b) && a.top === b.top && a.bottom === b.bottom && a.left === b.left && a.right === b.right;
}
export function isElementPositionContains(container, target) {
  var containerLeft = container.left,
      containerRight = container.right,
      containerTop = container.top,
      containerBottom = container.bottom;
  var targetLeft = target.left,
      targetRight = target.right,
      targetTop = target.top,
      targetBottom = target.bottom;
  var hc = containerLeft <= targetLeft && containerRight >= targetRight;
  var vc = containerTop <= targetTop && containerBottom >= targetBottom;
  return hc && vc;
}
export function isElementPositionCross(container, target) {
  var containerLeft = container.left,
      containerRight = container.right,
      containerTop = container.top,
      containerBottom = container.bottom;
  var targetLeft = target.left,
      targetRight = target.right,
      targetTop = target.top,
      targetBottom = target.bottom;
  var nhc = containerLeft > targetRight || containerRight < targetLeft;
  var nvc = containerTop > targetBottom || containerBottom < targetTop;
  return !nhc && !nvc;
}
export function isFixed(element) {
  if (!isClient()) {
    return false;
  }

  if (element === document.body) {
    return false;
  }

  if (getComputedStyle(element).position === 'fixed') {
    return true;
  }

  return element.parentNode ? isFixed(element.parentNode) : false;
}
export function isSticky(element) {
  if (!isClient()) {
    return false;
  }

  if (element === document.body) {
    return false;
  }

  if (getComputedStyle(element).position === 'sticky') {
    return true;
  }

  return element.parentNode ? isSticky(element.parentNode) : false;
}
export function getDefaultElementScroll() {
  return {
    scrollLeft: 0,
    scrollTop: 0
  };
}
export function getDocScroll() {
  if (!isClient()) {
    return getDefaultElementScroll();
  }

  return {
    scrollTop: document.body.scrollTop + document.documentElement.scrollTop,
    scrollLeft: document.body.scrollLeft + document.documentElement.scrollLeft
  };
}
export function getElementScroll(elem) {
  if (!isClient() || !elem) {
    return getDefaultElementScroll();
  }

  var realElem = elem === document.body || elem === document.documentElement ? window : elem;

  if (isWindow(realElem)) {
    return {
      scrollTop: realElem.pageYOffset,
      scrollLeft: realElem.pageXOffset
    };
  }

  return {
    scrollLeft: elem.scrollLeft,
    scrollTop: elem.scrollTop
  };
}
export function closest(ele, className) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var elem = ele;
  context = context || document.body;

  while (elem && elem !== context) {
    if (elem.classList.contains(className)) {
      return elem;
    }

    elem = elem.parentElement;
  }

  return false;
}
/**
 * 获取元素内容大小
 *
 * @param element 要获取的元素
 * @param fixHeight 固定高度
 * @param fixWidth 固定宽度
 */

export function getElementContentSize(element) {
  var fixHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var fixWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!isClient()) {
    return getDefaultElementSize();
  }

  var needSwap = {};

  if (!fixHeight) {
    needSwap.height = 'auto';
  }

  if (!fixWidth) {
    needSwap.width = 'auto';
  }

  return swap(element, needSwap, function () {
    return {
      width: Math.ceil(element.offsetWidth),
      height: Math.ceil(element.offsetHeight)
    };
  });
}
export function addClass(ele, className) {
  if (!ele) {
    return;
  }

  var tokens = className.split(' ').filter(function (t) {
    return !!t && !ele.classList.contains(t);
  });

  if (tokens.length) {
    var _ele$classList;

    (_ele$classList = ele.classList).add.apply(_ele$classList, _toConsumableArray(tokens));
  }
}
export function removeClass(ele, className) {
  if (!ele) {
    return;
  }

  var tokens = className.split(' ').filter(function (t) {
    return !!t && ele.classList.contains(t);
  });

  if (tokens.length) {
    var _ele$classList2;

    (_ele$classList2 = ele.classList).remove.apply(_ele$classList2, _toConsumableArray(tokens));
  }
}
var styleMap = isClient() ? document.createElement('div').style : {};
export function getPrefixedStyleKey(styleKey) {
  if (!styleKey.length) {
    return [];
  }

  var lowerKey = "".concat(styleKey[0].toLowerCase()).concat(styleKey.slice(1));
  var upperKey = "".concat(styleKey[0].toUpperCase()).concat(styleKey.slice(1));
  return getPrefixedStyleKey.prefixes.map(function (prefix) {
    return prefix ? "".concat(prefix).concat(upperKey) : lowerKey;
  }).filter(function (key) {
    return key in styleMap;
  });
}
getPrefixedStyleKey.prefixes = ['', 'webkit', 'moz', 'MS', 'o'];
export function getPrefixedEventKey(eventKey) {
  if (!eventKey.length) {
    return [];
  }

  var lowerKey = "".concat(eventKey[0].toLowerCase()).concat(eventKey.slice(1));
  var upperKey = "".concat(eventKey[0].toUpperCase()).concat(eventKey.slice(1));
  return getPrefixedEventKey.prefixes.reduce(function (prev, prefix) {
    var prefixedLowerKey = "".concat(prefix).concat(eventKey).toLowerCase();
    var camelCaseKey = prefix ? "".concat(prefix).concat(upperKey) : lowerKey;

    if (isClient() && "on".concat(prefixedLowerKey) in window) {
      return prev.concat(prefixedLowerKey, camelCaseKey);
    }

    return prev;
  }, []);
}
getPrefixedEventKey.prefixes = ['', 'webkit', 'moz', 'MS', 'o'];
export function getScrollbarWidth() {
  if (!isClient()) {
    return 0;
  }

  var innerHeight = window.innerHeight || document.documentElement.clientHeight;

  if (document.body.scrollHeight > innerHeight) {
    return 0;
  }

  var element = document.createElement('div');
  element.style.cssText = "\n        overflow: scroll;\n        position: absolute;\n        top: -99px;\n        left: -99px;\n        width: 99px;\n        height: 99px;\n        opacity: 0;\n    ";
  document.body.appendChild(element);
  var scrollbarWidth = element.offsetWidth - element.clientWidth;
  document.body.removeChild(element);
  return scrollbarWidth;
}